import React, { Component, Fragment } from 'react'


//Component
import CheckBox from '../../../components/atoms/CheckBox'


class FormComponent extends Component {
    onChangeHandle = () => {
    
    }

    render () {
        return (
            <div className='container'>
                <h1 className='h1 mt-2 mb-5'>Form Component</h1>

                <form className='d-flex flex-column'>
                    <div className='form-group'>
                        <label>CheckBox</label>

                        <div className='form-check-wrapper'>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" />
                                <label className="form-check-label" htmlFor="inlineCheckbox1">1</label>
                            </div>
                            
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2" />
                                <label className="form-check-label" htmlFor="inlineCheckbox2">2</label>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}

export default FormComponent;